export enum PlanType {
  FOUNDATION_PLAN = "FOUNDATION_PLAN",
  FOUNDATION_UTILITY_PLAN = "FOUNDATION_UTILITY_PLAN",
  STRUCTURAL_PLAN = "STRUCTURAL_PLAN",
  FLOOR_PLAN = "FLOOR_PLAN",
  BACKGROUND_PLAN = "BACKGROUND_PLAN",
  SUMMARY_PLAN = "SUMMARY_PLAN",
  FLOOR_MATERIALS_PLAN = "FLOOR_MATERIALS_PLAN",
  ELECTRICAL_PLAN = "ELECTRICAL_PLAN",
  ROOF_PLAN = "ROOF_PLAN",
  ROOF_BACKGROUND_PLAN = "ROOF_BACKGROUND_PLAN",
  BROCHURE_SUMMARY_PLAN = "BROCHURE_SUMMARY_PLAN",
  BROCHURE_SUMMARY_ELECTRICAL_PLAN = "BROCHURE_SUMMARY_ELECTRICAL_PLAN",
  VIEWPORT_PLAN = "VIEWPORT_PLAN",
}
